<template>
  <div class="auth-page">
    <div class="container container-height">
       
      <div class="row">
        <div class="col-md-5 mx-auto">
                          
          <form v-on:submit.prevent="onSubmit">
            <div class="logincontainer-shadow mt-5 p-4">
               <div class="row pb-3">
                 <div class="col-md-12 text-center">
                 <img v-bind:src="cdnUrl" class="form-group"  width="180">
                             
                   <h2>Verify Auth Code</h2>
                </div> 
               </div>
                
                <div class="form-group has-icon">
                    <input type="text" v-model="loginForm.totp" maxlength = "6" class="form-control" :class="{ 'is-invalid': submitted && v$.loginForm.totp.$error }" placeholder="Auth Code">
                    <span class="icon-lock-closed form-control-feedback"></span>
                    <div v-for="error of v$.loginForm.totp.$errors" :key="error.$uid" class="invalid-feedback">
                                            {{ error.$message }}
                                        </div>
                    <!-- <div v-if="submitted && !v$.loginForm.totp.required" class="invalid-feedback">Auth Code is required</div>
                    <div v-if="submitted && !v$.loginForm.totp.minLength" class="invalid-feedback">6 digit Auth Code is required</div>
                    <div v-if="submitted && !v$.loginForm.totp.maxLength" class="invalid-feedback">6 digit Auth Code is required</div> -->
               </div>
              <input type="hidden" v-model="loginForm.tempToken">
                    <button  class="btn btn-success btn-lg btn-block">
                                Verify
                    </button>   <br/>
                
            </div>  
                     
          </form>          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength,helpers} from "@vuelidate/validators";
export default {
  name: "verify",
  data() {
    return {
      v$: useVuelidate(),
      cdnUrl :process.env.VUE_APP_CDN_URL+'/img/paysharp.png',
      loginForm:{
            totp: '',
            tempToken: ''
      },
      submitted:false,
    };
  },
  
  validations(){
    return {
      loginForm:{  
        totp: { required:helpers.withMessage("Auth Code is required", required),
           minLength: helpers.withMessage("6 digit Auth Code is required", minLength(6)) ,
            maxLength: helpers.withMessage("6 digit Auth Code is required", maxLength(6))  }
      }
    } 
  },  
  methods: {
    async onSubmit() {    
      try{
        this.submitted = true;
        this.v$.$touch();             
        if (this.v$.$invalid) {
          return false;
        }
        else{        
          this.loginForm.tempToken = this.$store.state.user.tempToken;
          await this.$store.dispatch('user/loginstep2', this.loginForm); 
          this.$router.push('/dashboard');          
        }
      } catch(err){
      }   
     
    }
  }
};
</script>

